import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../../utlities/core.constants";
import { UserContext } from "../UserContext";

export const ProductContext = React.createContext({})

// eslint-disable-next-line no-unused-vars
export const ProductConsumer = ProductContext.Consumer;

// eslint-disable-next-line react/prop-types
export function ProductProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const { user } = useContext(UserContext);

  const fetchProducts = async () => {
    try {
      setProducts([]);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching products:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/category/all`);
      setCategories(response.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching categories:', error);
    }
  }

  useEffect(() => {
    (async() => {
      await fetchProducts();
    })();
  }, [user]);


  useEffect(() => {
    (async () => {
      await fetchCategories();
    })();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const resetProducts = () => {
    setProducts([]);
  };

  const contextValue = useMemo(() => ({
    products,
    categories,
    fetchProducts,
    fetchCategories
  }), [products, categories]);

  return (
    <ProductContext.Provider value={contextValue} >
      {children}
    </ProductContext.Provider>
  );
}
export default ProductContext;
